import * as auth from "./auth";
import * as articles from "./articles";
import * as common from "./common";
import * as videos from "./videos";
import * as chat from "./chat";
import * as search from "./search";
import * as notifications from "./notifications";

export const repository = {
  auth,
  articles,
  common,
  videos,
  chat,
  search,
  notifications,
};
